import { useState, useRef, useEffect } from 'react'

import { doGet } from 'providers/api'
import endpoint from 'middleware/sagas/endpoint'

const useNoteImage = (noteImage, isAuthenticated) => {
  const [blobUrl, setBlobUrl] = useState(null)
  const blobUrlRef = useRef(null)

  useEffect(() => {
    setBlobUrl(null)

    if (!noteImage) return () => undefined

    let active = true

    if (typeof noteImage !== 'string') {
      blobUrlRef.current = URL.createObjectURL(noteImage)
      setBlobUrl(blobUrlRef.current)
    } else if (isAuthenticated) {
      doGet({ url: `${endpoint.followUp.noteImage}${encodeURIComponent(noteImage)}`, arraybuffer: 'blob' }).then(res => {
        if (!active || !res) return
        blobUrlRef.current = URL.createObjectURL(res.data)
        setBlobUrl(blobUrlRef.current)
      })
    }

    return () => {
      active = false
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
        blobUrlRef.current = null
      }
    }
  }, [noteImage, isAuthenticated])

  return blobUrl
}

export default useNoteImage
